import { useSelector as useReduxSelector, useDispatch as useReduxDispatch } from 'react-redux';

export function useSelector(selector, equalityFn = null) {
    return useReduxSelector(selector, equalityFn);
}

export function useDispatch() {
    return useReduxDispatch();
}
